import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { CookiePreferenceCenter } from "./CookiePreferenceCenter";
import { useCookieConsentBanner } from "./useCookieConsent";

export function CookieConsent() {
  const { t } = useLanguage();
  const {
    isVisible,
    showPreferenceCenter,
    preferences,
    handleAcceptAll,
    handleRejectAll,
    handleCustomize,
    handleClosePreferenceCenter,
    handleSavePreferences,
  } = useCookieConsentBanner();

  return (
    <>
      {isVisible && (
        <div
          role="dialog"
          aria-label={t.cookieConsent.bannerTitle}
          className="fixed bottom-0 inset-x-0 z-[60] bg-card border-t border-border shadow-lg animate-slide-up motion-reduce:animate-none"
        >
          <div className="max-w-5xl mx-auto px-4 py-4 sm:px-6 sm:py-5">
            <div className="flex flex-col sm:flex-row sm:items-center gap-4">
              <div className="flex-1 text-start">
                <p className="text-sm font-semibold text-foreground mb-1">
                  {t.cookieConsent.bannerTitle}
                </p>
                <p className="text-sm text-muted-foreground">
                  {t.cookieConsent.bannerDescription}{" "}
                  <Link
                    to="/privacy"
                    className="underline hover:text-foreground"
                  >
                    {t.cookieConsent.learnMore}
                  </Link>
                </p>
                <div className="flex justify-start gap-3 text-xs mt-2">
                  <button
                    onClick={handleCustomize}
                    className="text-muted-foreground/70 hover:text-muted-foreground underline-offset-2 hover:underline"
                  >
                    {t.cookieConsent.customize}
                  </button>
                  <span className="text-muted-foreground/40">|</span>
                  <button
                    onClick={handleRejectAll}
                    className="text-muted-foreground/70 hover:text-muted-foreground underline-offset-2 hover:underline"
                  >
                    {t.cookieConsent.rejectAll}
                  </button>
                </div>
              </div>
              <div className="sm:shrink-0">
                <Button size="sm" className="w-full sm:w-auto" onClick={handleAcceptAll}>
                  {t.cookieConsent.acceptAll}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      <CookiePreferenceCenter
        isOpen={showPreferenceCenter}
        onClose={handleClosePreferenceCenter}
        onSave={handleSavePreferences}
        currentAnalytics={preferences.analytics}
      />
    </>
  );
}
